<template>
  <div class="warp">
    <navBox :page="'Serve'"></navBox>
    
    <div class="">

      <Secondary :bgImage="bgImage" :Cntitle="Cntitle" :Entitle="Entitle">
          <template>
            <div  class="custom-layout">

                <div class="paragraph">
                  <div>技术支持</div>
                  <div>
                    拥有专业的技术团队，确保系统稳定运行，为用户提供最佳体验。
                  </div>
                </div>

                <div class="paragraph">
                  <div>定制服务</div>
                  <div>
                    根据不同需求提供个性化定制方案，满足各类击剑赛事与活动的特殊需求。
                  </div>
                </div>

                <div class="paragraph">
                  <div>创新迭代</div>
                  <div>
                    紧跟行业趋势，不断优化系统功能与性能，为用户提供更多惊喜与便利。
                  </div>
                </div>

            </div>
        </template>
      </Secondary>

    </div>
  </div>
</template>

<script>
import NavBox from '@/components/navBox.vue';
import Secondary from '../components/secondary.vue';
export default {
  name: 'ServePage',
  components:{ Secondary, NavBox },
  data(){
    return{
      Entitle: "SERVICE AND SUPPORT",
      Cntitle: "服务与支持",
      bgImage:"https://img.fencerspage.com/upload/oss/club/contest/20250317/270167d7dcd565d11.jpg",
    }
  },

  
  methods:{
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px;  // 屏幕宽度


.warp {
  margin: 0 auto;
  width: 100vw;
}

.media_box{
  width: 100vw;
  height: 50vw;
  font-size: 0.88vw; //17

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    height:600px;  // 0.5*width
  }
}

.custom-layout{
  font-size: 1.85em;
  letter-spacing: 0.05em;

  .text-indent{
    text-indent: 2em;
  }

  .paragraph{
    padding-bottom: 3em;
    line-height: 1.5em;
  }
}
</style>
